import React from "react";
import { Box, Typography, useTheme } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolioNew/portfolioSlice";

import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

import { selectIsLoading, selectHasErrors, selectMostCommonStoreSize } from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";

const MostCommonStoreSize = () => {
    const theme = useTheme();
    const colourPalette = useColourPalette();
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const { selectedStore: selectedStoreValue, comparator: comparatorValue } = useAppSelector(selectMostCommonStoreSize);
    const label = `Most common store size in your ${selectedStore?.name} store's retail zone`;
    const selectedStoreFormattedValue = selectedStoreValue ? `${selectedStoreValue?.label} (${selectedStoreValue?.sizeRange})` : "Unknown";
    const comparatorFormattedValue = comparatorValue ? `${comparatorValue?.label} (${comparatorValue?.sizeRange})` : "Unknown";

    return (
        <Box width="100%" height="100%" data-cy="most-common-store-size">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h4" component="div" style={{ color: colourPalette.comparators[0], fontWeight: theme.typography.fontWeightMedium }}>
                        {selectedStoreFormattedValue}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {comparatorFormattedValue}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${selectedComparator?.name} `}
            />
        </Box>
    );
};

export default MostCommonStoreSize;
